export const CALL_PLAN_RESULTS = [
    { id: 1, label: "Gözləyir", cls: "text-amber-700 bg-amber-50 border-amber-300" },
    { id: 2, label: "Danışıldı / Razılaşdıq", cls: "text-emerald-700 bg-emerald-50 border-emerald-300" },
    { id: 3, label: "Cavab vermədi", cls: "text-rose-700 bg-rose-50 border-rose-300" },
    { id: 4, label: "Satılıb / Kiraya verilib", cls: "text-sky-700 bg-sky-50 border-sky-300" },
    { id: 5, label: "Satış dayandırılıb", cls: "text-slate-700 bg-slate-100 border-slate-300" },
    { id: 6, label: "Narahat etməyin", cls: "text-red-700 bg-red-50 border-red-300" },
];